<template>
  <div id="rodape-tabela-compras">
<!--    <span class="quadrado" />-->
<!--    <span v-text="'Sazonal'" class="ml-1 mr-3 font-12" @click="$emit('abrir-dialog-sazonalidades')" style="cursor: pointer"/>-->

    <div class="d-flex align-center" v-if="ativar_filtro_produtos_inativos_tela_compras">
      <div class="quadrado-15" style="background-color: red;"></div>
      <span class="ml-1 font-13">Produto Fora de Linha</span>
    </div>

    <div class="d-flex align-center ml-3" v-if="ativar_filtro_produtos_inativos_tela_compras">
      <div class="quadrado-15" style="background-color: orange;"></div>
      <span class="ml-1 font-13">Produto inativo para venda</span>
    </div>

    <v-spacer />

    <ExibirApenasCombinacoesSwitch />

    <v-switch
      v-if="COMPRA_DISTRIBUIDA_POR_FILIAL"
      v-model="MULTIFILIAL_OCULTAR_PRODUTOS_CARRINHO"
      hide-details
      dense
      color="#A51B32"
      class="mr-3"
    >
      <template #label>
        <span class="ml-1 font-12">Ocultar produtos adicionados no carrinho</span>
      </template>
    </v-switch>

    <span v-text="`Qtd. Itens: ${Helpers.formatarValor(qtdItens)}`" class=" font-12" />
  </div>
</template>

<script>
import ExibirApenasCombinacoesSwitch from "@/components/produto/DemandaCombinada/ExibirApenasCombinacoesSwitch.vue";
import Api from '@/api/api.js';

export default {
  name: "RodapeTabela",
  components: {ExibirApenasCombinacoesSwitch},
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: ['qtdItens', 'modelValue'],
  data: () => ({ ativar_filtro_produtos_inativos_tela_compras: false }),
  mounted() {
    this.buscarAtivarFiltroProdutosInativosTelaCompras();
  },
  computed: {
    COMPRA_DISTRIBUIDA_POR_FILIAL() {
      return this.$store.getters['CompraDistribuidaPorFilial/get_distribuir_por_filial'];
    },
    MULTIFILIAL_OCULTAR_PRODUTOS_CARRINHO: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        localStorage.flag_multifiliais_ocultar_produto_carrinho = valor ? 'S' : 'N';
        return this.$emit('update:modelValue', valor);
      }
    },
  },
  methods: {
    buscarAtivarFiltroProdutosInativosTelaCompras () {
      Api.get('configuracao/get_ativar_filtro_produtos_inativos_tela_compras').then(response => this.ativar_filtro_produtos_inativos_tela_compras = response.data.ativar_filtro_produtos_inativos_tela_compras)
    }
  }
}
</script>

<style scoped>
#rodape-tabela-compras {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 7px 7px;
  border: 1px solid #dcdcdc;
  border-top: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.quadrado {
  width: 15px;
  height: 15px;
  background-color: #f44336;
}
</style>
